import styled from 'styled-components';

export const RightSide = styled.div``;
